import { render, staticRenderFns } from "./pavilion-add.vue?vue&type=template&id=038fb6b1&scoped=true&"
import script from "./pavilion-add.vue?vue&type=script&lang=js&"
export * from "./pavilion-add.vue?vue&type=script&lang=js&"
import style0 from "./pavilion-add.vue?vue&type=style&index=0&id=038fb6b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038fb6b1",
  null
  
)

export default component.exports